import { createStyles, makeStyles } from "@material-ui/core";
import { UIKIT_COLORS } from "../../ui-kit/theme/colors";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "block",
      width: "100%",
      "& > * + *": { marginTop: 12 },
    },
    label: {
      display: "block",
      fontSize: 12,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_MUTED,
      letterSpacing: "0.3px",
      textTransform: "uppercase",
      lineHeight: "16px",
    },
    card: {
      border: `1px solid ${UIKIT_COLORS.DANGER_BORDER}`,
      borderRadius: 8,
      backgroundColor: UIKIT_COLORS.DANGER_BG,
      overflow: "hidden",
    },
    cardRow: {
      display: "flex",
      alignItems: "center",
      padding: 13,
      "& > * + *": { marginLeft: 16 },
    },
    thumbnail: {
      width: 80,
      height: 48,
      flexShrink: 0,
      backgroundColor: UIKIT_COLORS.THUMBNAIL_BG,
      border: `1px solid ${UIKIT_COLORS.BORDER_DARK}`,
      borderRadius: 4,
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": { width: "100%", height: "100%", objectFit: "cover" },
    },
    fileName: {
      flex: "1 1 auto",
      minWidth: 0,
      fontSize: 14,
      fontWeight: 600,
      color: UIKIT_COLORS.TEXT_PRIMARY,
      lineHeight: "20px",
    },
    undoBtn: {
      flexShrink: 0,
      marginLeft: "auto",
      fontSize: 11,
      fontWeight: 500,
      color: `${UIKIT_COLORS.TEXT_SECONDARY} !important`,
      textDecoration: "underline",
      textTransform: "none" as const,
      padding: "0 2px",
      minWidth: "unset",
      "&:hover": { background: "transparent", color: `${UIKIT_COLORS.DANGER} !important` },
    },
    reasonsList: {
      borderTop: `1px solid ${UIKIT_COLORS.DANGER_BORDER}`,
      padding: "10px 13px 12px",
      display: "flex",
      flexDirection: "column",
      "& > * + *": { marginTop: 4 },
    },
    reasonsTitle: {
      fontSize: 11,
      fontWeight: 600,
      color: UIKIT_COLORS.DANGER,
      textTransform: "uppercase",
      letterSpacing: "0.3px",
      marginBottom: 4,
    },
    reasonItem: {
      display: "flex",
      alignItems: "flex-start",
      fontSize: 12,
      fontWeight: 500,
      color: UIKIT_COLORS.TEXT_DARK,
      lineHeight: "18px",
      "&::before": {
        content: '"•"',
        color: UIKIT_COLORS.DANGER,
        flexShrink: 0,
        marginRight: 6,
        marginTop: 1,
      },
    },
  })
);
